
export function extractNumberFromUrl(): string | null {
  const pathname = window.location.pathname;
  const pathSegments = pathname.split('/').filter(segment => segment.length > 0);
  const lastSegment = pathSegments.at(-1);

  if (!lastSegment || lastSegment === 'agreement-details') {
    return null;
  }

  return lastSegment;
}
